import React, { useCallback } from "react";
import List, { IItemDraggingProps, ItemDragging } from "devextreme-react/list";

import useProjectContext from "@/services/context/project/use-project-context.ts";
import useProjectOrganisationContext from "@/pages/takeoff/context/project-organisation/use-project-organisation-context.ts";

import ProjectLockStatus from "@/models/enums/project-lock-status.ts";

import FileType from "@/models/enums/file-type.ts";
import FileData2D from "@/pages/takeoff/context/project-organisation/models/file-data-2d.ts";
import TruncatedText from "@/components/text/truncated-text";

type ScopeType = 'project' | 'building' | 'storey';

export interface File2DListProps {
    itemsSource: FileData2D[];

    allowReodering?: boolean;
    scope: ScopeType;
    buildingId?: string;
    storeyId?: string;
    noDataText?: string;
}

const File2DList: React.FC<File2DListProps> = ({ itemsSource, scope, buildingId, storeyId, allowReodering = false, noDataText = 'Aucun fichier' }) => {
    const { projectLockStatus } = useProjectContext();

    const { addFile, removeFile, getPlanFileData, setPlanFileData, removePlanFileData} = useProjectOrganisationContext();

    const ItemTemplate = function (item: FileData2D) {
        return (
            <div className='flex flex-row w-full items-center pr-1'>
                <TruncatedText className='flex-1 select-none cursor-default' text={`${item.name}`} />

                {/* {(scope === 'storey' && buildingId != null && storeyId != null) && */}
                {/*    <ButtonLockDependent variant='ghost' size='2xs' disabled={isSaving} className={isDirty ? 'cursor-not-allowed' : 'cursor-pointer'} */}
                {/*        onClick={() => { */}
                {/*            if (isDirty) { */}
                {/*                toast.info("Impossible d'éditer les plans tant que le projet n'est pas sauvegardé.", { autoClose: 3000, closeOnClick: true }); */}
                {/*            } else { */}
                {/*                setRoute('organisation', new URLSearchParams({ fileId: item.id }), 'organisation'); */}
                {/*            } */}
                {/*        }}> */}
                {/*        <FontAwesomeIcon icon={faRuler} /> */}
                {/*    </ButtonLockDependent> */}
                {/* } */}
            </div>
        )
    }

    const onDragStart = useCallback<NonNullable<IItemDraggingProps["onDragStart"]>>(
        (e) => {
            e.itemData = { item: itemsSource[e.fromIndex], lastBuildingId: buildingId, lastStoreyId: storeyId, lastScope: scope };
        }, [itemsSource, buildingId, storeyId, scope]
    )

    const onAdd = useCallback<NonNullable<IItemDraggingProps["onAdd"]>>(
        (e) => {
            const { item, lastStoreyId } = e.itemData as { item: FileData2D, lastBuildingId: string, lastStoreyId: string, lastScope: ScopeType };
            if (scope === 'storey' && storeyId) {
                const data = getPlanFileData(lastStoreyId, item.id)
                if (data) {
                    setPlanFileData(storeyId, item.id, data);
                }
            }
            addFile(scope, FileType.File2D, item.id, item.name, item.revision, item.relativePath, item.fileMetaObject, buildingId, storeyId);
        }, [addFile, getPlanFileData, setPlanFileData, buildingId, scope, storeyId]
    )

    const onRemove = useCallback<NonNullable<IItemDraggingProps["onRemove"]>>(
        (e) => {
            const { item, lastScope, lastStoreyId } = e.itemData as { item: FileData2D, lastBuildingId: string, lastStoreyId: string, lastScope: ScopeType };
            if (lastScope === 'storey') {
                removePlanFileData(lastStoreyId, item.id);
            }
            removeFile(scope, FileType.File2D, item.id, buildingId, storeyId);
        }, [removeFile, removePlanFileData, scope, buildingId, storeyId]
    );

    return (
        <List dataSource={itemsSource} keyExpr={'id'} displayExpr={'name'}
              itemRender={ItemTemplate}
              repaintChangesOnly={true} noDataText={noDataText}
              hoverStateEnabled={false} selectByClick={false} focusStateEnabled={false} activeStateEnabled={false}>
            {projectLockStatus === ProjectLockStatus.LOCK_OWNED &&
                <ItemDragging group={`file-2D`} dropFeedbackMode={'push'} allowDropInsideItem={false}
                              allowReordering={allowReodering}
                              onDragStart={onDragStart}
                              onAdd={onAdd} onRemove={onRemove} />
            }
        </List>
    )
}

export default File2DList;